import { Component, Vue } from 'vue-property-decorator';

@Component<Hamburger>({
  components: {
  },
})
export default class Hamburger extends Vue {
  protected hamburgerActive: boolean = false;
  public mounted() {
    //
  }

  protected click() {
    this.hamburgerActive = !this.hamburgerActive;
    this.$emit('clicked');
  }
}

